import React from "react";
import { chatMessengerShow } from "@origin-digital/event-dispatcher";
import {
  Box,
  Card,
  Column,
  Columns,
  Heading,
  Stack,
  StackSection,
  Text,
} from "@origin-digital/ods-core";
import { alert } from "@origin-digital/reporting-client";
import {
  shouldSendOfferTabAnalytics,
  formatOfferTabForAnalytics,
  IOfferTab,
  IOfferTabAnalytics,
  OfferTabAnalytics,
} from "../Offers/offerTab";
import content from "./content.json";
import { APP_NAME } from "../../consts";
import { IconPhone } from "@origin-digital/ods-icons";

export const MeteredLPGBlocking = ({
  offerTab = {} as IOfferTab,
  analyticsSent,
  setAnalyticsSent = () => {},
  shouldFireAlert = false,
}: {
  offerTab?: IOfferTab;
  analyticsSent?: IOfferTabAnalytics;
  setAnalyticsSent?: (key: IOfferTabAnalytics) => void;
  shouldFireAlert?: boolean;
} = {}) => {
  if (shouldFireAlert && shouldSendOfferTabAnalytics(offerTab, analyticsSent)) {
    setAnalyticsSent(OfferTabAnalytics(offerTab, analyticsSent));
    alert.base("notification", {
      appName: APP_NAME,
      alertMessage: content.heading,
      alertCode: formatOfferTabForAnalytics(offerTab),
    });
  }

  return (
    <StackSection width="large" data-id="metered-lpg-blocking-section">
      <Card padding="medium" data-id="metered-lpg-blocking-card">
        <Stack space="xlarge" data-id="metered-lpg-blocking-content">
          {/* Header */}
          <Columns direction={{ xs: "column", lg: "row-reverse" }}>
            <Column width="content">
              {/* Graphic */}
              <Box
                display="flex"
                marginBottom={{ xs: "large", lg: "none" }}
                marginLeft={{ xs: "none", lg: "large" }}
              >
                <img
                  src={content.imageUrl}
                  width="96"
                  height="96"
                  alt={content.imageAlt}
                  data-id="metered-lpg-blocking-image"
                />
              </Box>
            </Column>
            <Column>
              {/* Body */}
              <Stack>
                <Stack space="xsmall">
                  <Text
                    variant="subtitle"
                    data-id="metered-lpg-blocking-subtitle"
                  >
                    {content.subtitle}
                  </Text>
                  <Heading variant="h2" data-id="metered-lpg-blocking-title">
                    {content.heading}
                  </Heading>
                </Stack>
                <Text data-id="metered-lpg-blocking-description">
                  {content.description}
                </Text>
              </Stack>
            </Column>
          </Columns>

          {/* CTA */}
          <Stack space="medium" data-id="metered-lpg-blocking-cta">
            <Text
              variant="subtitle-small"
              weight="medium"
              data-id="metered-lpg-blocking-cta-text"
            >
              {content.ctaHeading}
            </Text>
            <Box
              display="inline-block"
              data-id="metered-lpg-blocking-call-btn-wrapper"
            >
              <a
                data-id="metered-lpg-blocking-call-btn"
                href={content.phoneHref}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#F9A825",
                  color: "#000",
                  padding: "12px 24px",
                  borderRadius: "24px",
                  textDecoration: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                <span>
                  <IconPhone variant="solid" color="neutralDark" />
                </span>
                {content.callButtonText}
              </a>
            </Box>
          </Stack>

          {/* Verify */}
          <Card
            padding="small"
            backgroundColor="cardBackgroundSecondary"
            data-id="metered-lpg-blocking-verify-card"
          >
            <Stack space="small" data-id="metered-lpg-blocking-verify-content">
              <Text
                variant="body-small"
                weight="medium"
                data-id="metered-lpg-blocking-verify-text"
              >
                {content.verifyText}
              </Text>
              <Text
                variant="body-small"
                data-id="metered-lpg-blocking-verify-note"
              >
                {content.verifyNote}
                <button
                  data-id="metered-lpg-blocking-verify-chat-btn"
                  onClick={() => chatMessengerShow({})}
                  style={{
                    background: "none",
                    border: "none",
                    color: "inherit",
                    cursor: "pointer",
                    textDecoration: "underline",
                    padding: 0,
                    font: "inherit",
                  }}
                >
                  chat to us online
                </button>
                {" or call "}
                <a
                  data-id="metered-lpg-blocking-verify-phone-link"
                  href={content.phoneHref}
                  style={{ textDecoration: "underline" }}
                >
                  13 35 74
                </a>
              </Text>
            </Stack>
          </Card>
        </Stack>
      </Card>
    </StackSection>
  );
};
